export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.7.2',
    name: 'fpar',
    versionDate: '2026-04-29T20:14:41.460Z',
};
export default versions;
